export default __webpack_public_path__ + "static/media/reference_gr_1.0ced76ce.svg";